export default {"src":"/_next/static/media/whoop-footer-logo-dark.53b25848.svg","height":23,"width":30,"blurWidth":0,"blurHeight":0};